module.exports = __webpack_public_path__ + "static/media/movie-candy-audience.1a58332f.png";